import { render, staticRenderFns } from "./doc-zoomer.vue?vue&type=template&id=7a8c0607&scoped=true&lang=pug&"
import script from "./doc-zoomer.vue?vue&type=script&lang=js&"
export * from "./doc-zoomer.vue?vue&type=script&lang=js&"
import style0 from "./doc-zoomer.vue?vue&type=style&index=0&id=7a8c0607&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8c0607",
  null
  
)

export default component.exports